/**
 * Editor tab ids. Kept apart from EventTypeEditor.tsx so the route's
 * validateSearch (which ships in the main chunk) doesn't pull in the editor.
 */
export type EditorTab = 'rules' | 'schema' | 'samples' | 'settings'
export const EDITOR_TABS: readonly EditorTab[] = ['rules', 'schema', 'samples', 'settings']
